// extracted by mini-css-extract-plugin
export default {"button":"scrollToTop_button__55DYr","button-body":"scrollToTop_button-body__VjTMB","hide":"scrollToTop_hide__o2T7t","show":"scrollToTop_show__v7ipP"};